import React, { useEffect } from 'react';
import Footer from './Footer';
import Breadcrumbs from './Breadcrumbs';
import '../labcomponents/labcss/privacy.css';

// Shared layout for Terms, Refund and Shipping policy pages.
export const SUPPORT_EMAIL = 'pranavshekhawat2@gmail.com';

export const Section = ({ id, title, children }) => (
  <>
    <section id={id} className="privacy-card mypadding">
      <h2>{title}</h2> <br />
      {children}
    </section> <br /><br />
  </>
);

export const List = ({ items }) => (
  <ul className="terms-list">{items.map((item) => <li className="bodytext" key={typeof item === 'string' ? item : item.key}>{item}</li>)}</ul>
);

export default function LegalPage({ title, documentTitle, tagline, effective, scope, children }) {
  useEffect(() => {
    document.title = documentTitle || `${title} | SoapLab`;
  }, [title, documentTitle]);

  return (
    <div className="sl-page privacy-page">
      <div className="pageheader borderleft">
        <Breadcrumbs items={[{ label: 'Home', to: '/' }, { label: title }]} />
        <div className="pageheader-row">
          <div className="pageheading">{title}</div>
        </div>
      </div>
      <div className="privacy-content borderleft">
        {tagline && <p className="privacy-hero__tagline mypadding">{tagline}</p>}
        <div className="privacy-meta borderbottom mypadding">
          <span>Effective date: {effective}</span>
          <span>{scope || 'Applies to soaplab.in and all SoapLab plans.'}</span>
        </div>
        <br />
        {children}
      </div>
      <Footer />
    </div>
  );
}
